// extracted by mini-css-extract-plugin
module.exports = {"input":"inputText_input__UDRIi","icon":"inputText_icon__jSUPt"};